/**
 * Generic legal page renderer — reads the markdown body from
 * /api/public/legal/{slug} and renders it. Used for: terms, privacy,
 * refunds, delivery.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fmtDate } from "@/lib/time";
import axios from "axios";
import { renderMarkdown } from "@/lib/markdown";
import PublicLayout from "./PublicLayout";

export default function LegalPage() {
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let active = true;
        axios.get(`${API}/public/legal/${slug}`)
            .then(r => { if (active) setPage(r.data); })
            .catch(e => { if (active) setError(e?.response?.data?.detail || "Failed to load page"); });
        return () => { active = false; };
    }, [slug]);

    return (
        <PublicLayout>
            <article className="prose-invert max-w-none" data-testid={`legal-page-${slug}`}>
                {error && <div className="text-rose-400 text-sm" data-testid="legal-error">{error}</div>}
                {!page && !error && <div className="text-muted-foreground text-sm">Loading…</div>}
                {page && page.slug === slug && (
                    <>
                        <header className="mb-6">
                            <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-foreground" data-testid="legal-title">{page.title}</h1>
                            {page.updated_at && <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground mt-2">Last updated · {fmtDate(page.updated_at)}</div>}
                        </header>
                        <div data-testid="legal-body">{renderMarkdown(page.body_md)}</div>
                    </>
                )}
            </article>
        </PublicLayout>
    );
}
